import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import { DragHandleOutlined } from '@mui/icons-material';
import EspecialidadesTabla from '../types/EspecialidadesTabla';
import ObtenerEspecialidades from '../functions/ObtenerEspecialidades';

interface ListarEspecialidadesProps {
    defaultItemsPerPage?: number;
    handleEdit: (especialidad: EspecialidadesTabla) => void;
    handleDelete: (especialidad: EspecialidadesTabla) => void;
    handleAdd: () => void
}

export const ListarEspecialidades: React.FC<ListarEspecialidadesProps> = ({ defaultItemsPerPage = 15, handleEdit, handleDelete, handleAdd, }) => {
  
  const [especialidades, setEspecialidades] = useState<EspecialidadesTabla[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  useEffect(() => {
    const fetchEspecialidades = async () => {
      try {
        const data = await ObtenerEspecialidades();
        setEspecialidades(data.especialidades);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener las especialidades:' + err);
        setLoading(false);
      }
    };

    fetchEspecialidades();
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'especialidad', label: 'ESPECIALIDAD', align: 'left' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'dado_de_baja', label: 'DADO DE BAJA', align: 'center' as const },
  ];

  const handleEditLocal = (especialidad: EspecialidadesTabla) => {
    handleEdit(especialidad);
  };

  const handleDeleteLocal = (especialidad: EspecialidadesTabla) => {
    handleDelete(especialidad);
  };

  const handleCredencialLocal = (especialidad: EspecialidadesTabla) => {
    console.log('Mostrar credencial', especialidad);
  }

  const handleUbicationLocal = (especialidad: EspecialidadesTabla) => {
    console.log('Mostrar ubicacion', especialidad);
  };

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Especialidades cargadas</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAdd}>Nueva Especialidad</button>
        </div>
      </div>
      <Tabla columns={columns} data={especialidades} onEdit={handleEditLocal} onDelete={handleDeleteLocal} itemsPerPage={itemsPerPage} onCredencial={handleCredencialLocal} onUbication={handleUbicationLocal} acciones={['editar','eliminar']}/>
    </div>
  );
};